"use client";
import CookieConsent, { Cookies as UserCookies } from "react-cookie-consent";
import Link from "next/link";
import Image from "next/image";
import { IconHeart, IconShieldCheck } from "@/lib/tabler-icons";

export const Cookies = () => (
	<CookieConsent
		location="none"
		buttonText="Aceptar"
		buttonStyle={{
			background: "#1f2a27",
			color: "#f6f1ea",
			borderRadius: "0.5rem",
			fontWeight: 600,
			padding: "0.5rem 1rem",
			fontSize: "0.875rem",
			minWidth: 0,
			border: "none",
			boxShadow: "none",
			transition: "all 0.2s ease",
			cursor: "pointer",
		}}
		enableDeclineButton
		declineButtonText="Rechazar"
		declineButtonStyle={{
			background: "transparent",
			color: "#545454",
			borderRadius: "0.5rem",
			fontWeight: 500,
			padding: "0.5rem 1rem",
			fontSize: "0.875rem",
			minWidth: 0,
			border: "1px solid #c8c8c8",
			boxShadow: "none",
			transition: "all 0.2s ease",
			cursor: "pointer",
		}}
		cookieName="cookies-consent"
		style={{
			position: "fixed",
			right: "1rem",
			bottom: "1rem",
			maxWidth: "24rem",
			borderRadius: "0.75rem",
			background: "#f6f1ea",
			display: "flex",
			alignItems: "center",
			gap: "0.75rem",
			marginLeft: "1rem",
			boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
			padding: "0.5rem",
			zIndex: 100,
			fontSize: "0.875rem",
			border: "1px solid #d9cfbd",
		}}
		expires={150}
		onAccept={() => UserCookies.set("cookies-consent", "true")}
		onDecline={() => UserCookies.remove("cookies-consent")}
		containerClasses="flex items-center"
		buttonWrapperClasses="flex gap-2 ml-auto"
		ariaAcceptLabel="Aceptar cookies"
		ariaDeclineLabel="Rechazar cookies"
	>
		<div className="flex items-center gap-2">
			<div className="flex-1 min-w-0 flex flex-col gap-2">
				<div className="flex items-center gap-2">
					<div className="relative">
						<div className="relative bg-white p-1 rounded-full shadow-sm border border-border">
							<Image
								src="/assets/brand/equilibrio-symbol.svg"
								alt="Logo Asociación Equilibrio"
								width={16}
								height={16}
								unoptimized
								className="w-4 h-4 object-contain"
							/>
						</div>
					</div>
					<span className="text-xs font-semibold text-gray-800">
						Asociación Equilibrio
					</span>
				</div>
				<p className="text-xs text-gray-600 leading-relaxed mb-1">
					Organización sin ánimo de lucro. Usamos cookies esenciales para
					continuar nuestro trabajo comunitario.
				</p>
				<div className="flex items-center gap-3 text-xs text-gray-500">
					<div className="flex items-center gap-1">
						<IconShieldCheck
							className="w-3 h-3 text-primary-500"
							aria-hidden="true"
						/>
						<span>Seguro</span>
					</div>
					<div className="flex items-center gap-1">
						<IconHeart className="w-3 h-3 text-rose-400" aria-hidden="true" />
						<span>Sin ánimo de lucro</span>
					</div>
				</div>
				<Link
					href="/politica-de-privacidad"
					target="_blank"
					className="inline-flex items-center gap-1 text-xs text-primary-900 hover:text-primary-950 font-medium mt-1 transition-colors"
				>
					Política de privacidad
					<IconShieldCheck className="w-3 h-3" aria-hidden="true" />
				</Link>
			</div>
		</div>
	</CookieConsent>
);

export default Cookies;
